module.exports = __webpack_public_path__ + "img/tuv-sud.e9e050f3.png";